import {Component, OnInit, ChangeDetectorRef, Injector, Output, EventEmitter} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CARDINFO, SUBSCRIPTIONINFO} from '../../../../gen/swagger-api';
import {AlertService} from '../../../shared/services/alert.service';
import {UpdateConnectivityParametersModalComponent} from '../update-connectivity-parameters/update-connectivity-parameters-modal.component';
import {LoadSubscriptionModalComponent} from '../load-subscription/load-subscription-modal.component';
import {AuditModalComponent} from '../audit-modal/audit-modal.component';
import {HistoryModalComponent} from '../history-modal/history-modal.component';
import {Observable} from 'rxjs/Observable';
import {HttpOperationsService} from '../../../shared/services/http-operations.service';
import {ModalBaseComponent} from '../modal-base-component';
import {DefaultService} from '../../../../gen/swagger-api/api/default.service';
import {ErrorHandlingService} from '../../../shared/services/error-handling-service';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {DeleteQuestionModalComponent} from '../delete-question-modal/delete-question-modal.component';

@Component({
  selector: 'app-card-details-modal',
  templateUrl: './card-details-modal.component.html',
  styleUrls: ['./card-details-modal.component.css'],
})
export class CardDetailsModalComponent extends ModalBaseComponent implements OnInit {

  cardInfo: CARDINFO;
  subscriptions: Array<SUBSCRIPTIONINFO>;
  bsModalRef: BsModalRef;
  showButton = false;
  fromCardPool: boolean = false;
  profileMessage = '';
  deleteMessage = '';
  fallbackMessage = '';
  cardStatus = '';

  @Output() action = new EventEmitter();

  constructor(
    private inject: Injector,
    private readonly modalService: BsModalService,
    private readonly defaultService: DefaultService,
    private readonly alertService: AlertService,
    private readonly changeDetector: ChangeDetectorRef,
    private _bsModalRef: BsModalRef,
    private errorHandlingService: ErrorHandlingService,
    private httpOperationsService: HttpOperationsService) {
    super(inject);
  }

  private loadCardDetails() {
    this.defaultService.cardsEidOrIccidGet(this.cardInfo.eis.eid).subscribe(cardDetailsInfo => {
        this.cardInfo = cardDetailsInfo;
      },
      error => {
        this.alertService.error('error loading cards');
      },
      () => {
        this.loadSubscriptions(this.cardInfo);
      });
  }

  public refresh() {
    this.loadCardDetails();
  }

  public ngOnInit() {
    this.loadCardDetails();
  }

  public loadSubscriptions(cardInfo: CARDINFO): void {
    this.cardStatus = cardInfo.lastSMTransactionStatus;
    this.defaultService.cardsEidProfilesGet(cardInfo.eis.eid).subscribe(subscriptions => {
        this.subscriptions = subscriptions;
        this.changeDetector.detectChanges();
      },
      (error) => {
        if (error) {
          if (!error.ok && error.statusText) {
            switch (error.status) {
              case 0:
                // API not reachable?
                this.alertService.error(error.statusText + ': Please check connection.');
                // FIXME: these alerts are not shown?
                break;
              default:
                this.alertService.error(error.statusText);
            }
          }
        }
      });
  }

  public updateConectivityParameters() {
    this.modalService.show(UpdateConnectivityParametersModalComponent, {});
  }

  public openLoadSubscriptionModal(subscription: CARDINFO) {

    if (this.cardStatus === 'IN_PROCESS') {
      this.alertService.infoModal('Please wait. Card is currently under processing.');
    } else {
      const subscriptions: Array<CARDINFO> = [subscription];
      var callback = () => {
        // this.closeModal();
      };
      const initialState = {
        subscriptions,
        callback
      };
      this.bsModalRef = this.modalService.show(LoadSubscriptionModalComponent, {initialState, class: 'modal-large'});
      this.bsModalRef.content.closeBtnName = 'Close';

      this.bsModalRef.content.action.take(1).subscribe((success) => {
        this.refresh();
      });
    }
  }

  public openAuditModal(subscription: CARDINFO) {
    if (this.cardStatus === 'IN_PROCESS') {
      this.alertService.infoModal('Please wait. Card is currently under processing.');
    } else {
      const subscriptions: Array<CARDINFO> = [subscription];
      var callback = () => {
        // this.closeModal();
      };

      const initialState = {
        subscriptions,
        callback
      };

      this.bsModalRef = this.modalService.show(AuditModalComponent, {initialState, class: 'modal-large'});
      this.bsModalRef.content.closeBtnName = 'Close';

      this.bsModalRef.content.action.take(1).subscribe((success) => {
        this.refresh();
      });
    }
  }

  public openHistoryModal(subscription: CARDINFO) {
    var callback = () => {
      //this.closeModal();
    };

    const initialState = {
      subscription,
      callback
    };
    this.bsModalRef = this.modalService.show(HistoryModalComponent, {initialState, class: 'modal-large'});
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  public deleteProfile(subscription: SUBSCRIPTIONINFO): void {
    if (this.cardStatus === 'IN_PROCESS') {
      this.alertService.infoModal('Please wait. Card is currently under processing.');
    } else if (subscription.status !== 'ENABLED' && !subscription.fallback) {
      this.bsModalRef = this.modalService.show(ConfirmDialogComponent);
      this.bsModalRef.content.type = 'delete';
      this.bsModalRef.content.iccid = subscription.iccid;

      this.bsModalRef.content.action.take(1).subscribe((success) => {
        if (success) {
          this.defaultService.cardsEidProfilesDelete(this.cardInfo.eis.eid, subscription.iccid).subscribe(() => {
              this.alertService.successModal('Deleting profile');
              setTimeout(() => {
                this.loadSubscriptions(this.cardInfo);
              }, 500);
              this.refresh();
            },
            (error) => {
              this.errorHandlingService.errorHandling(error);
            });
        }
      });
    }
  }

  public activateProfile(subscription: SUBSCRIPTIONINFO): void {
    if (this.cardStatus === 'IN_PROCESS') {
      this.alertService.infoModal('Please wait. Card is currently under processing.');
    } else if (subscription.status !== 'ENABLED') {

      this.bsModalRef = this.modalService.show(ConfirmDialogComponent);
      this.bsModalRef.content.type = 'enable';
      this.bsModalRef.content.iccid = subscription.iccid;

      this.bsModalRef.content.action.take(1).subscribe((success) => {
        if (success) {
          const observables: Observable<any>[] = [];
          observables.push(this.defaultService.cardsEidProfilesPost(this.cardInfo.eis.eid, subscription.iccid, true));
          this.executeCalls('Enabling profile', observables);
          this.refresh();
        }
      });
    }
  }

  public setFallbackProfile(subscription: any): void {
    if (this.cardStatus === 'IN_PROCESS') {
      this.alertService.infoModal('Please wait. Card is currently under processing.');
    } else if (!subscription.fallback) {

      this.bsModalRef = this.modalService.show(ConfirmDialogComponent);
      this.bsModalRef.content.type = 'fallback';
      this.bsModalRef.content.iccid = subscription.iccid;

      this.bsModalRef.content.action.take(1).subscribe((success) => {
        if (success) {
          const observables: Observable<any>[] = [];
          observables.push(this.defaultService.cardsEidFallbackPost(this.cardInfo.eis.eid, subscription.iccid));
          this.executeCalls('Setting Fallback', observables);
          this.refresh();
        }
      });
    }
  }

  private executeCalls(operationName: string, observables) {
    Observable.forkJoin(observables).subscribe(
      result => {
        // if (errors.length === 0) {
        this.alertService.successModal(operationName + ' successful');
        // this.closeModal();
        setTimeout(() => {
          this.loadSubscriptions(this.cardInfo);
        }, 500);

      },
      error => {
        {
          console.error(error);
          this.errorHandlingService.errorHandling(error);
        }
      }
    );
  }


  public closeModal(): void {
    this.action.emit();
    this._bsModalRef.hide();
  }

  public setProfileTooltip(i) {
    if (this.subscriptions[i].status.toString() === 'ENABLED') {
      this.profileMessage = 'Profile is already enabled';
    }
    else if(this.subscriptions[i].status.toString() === 'CREATED'){
      this.profileMessage = 'Profile installation not completed - enabling not possible';
    }
    else {
      this.profileMessage = 'Enable profile';
    }
    return this.profileMessage;
  }

  public seteDeleteTooltip(i) {
    if (this.subscriptions[i].status.toString() !== 'ENABLED' && !this.subscriptions[i].fallback) {
      this.deleteMessage = 'Delete profile';
    } else {
      this.deleteMessage = 'Deletion of enabled or fallback profile is not allowed';
    }
    return this.deleteMessage;
  }

  public setFallbackTooltip(i) {
    if (!this.subscriptions[i].fallback && this.subscriptions[i].status.toString() !== 'CREATED') {
      this.fallbackMessage = 'Set fallback attribute';
    }
    else if(!this.subscriptions[i].fallback && this.subscriptions[i].status.toString() === 'CREATED'){
      this.fallbackMessage = 'Profile installation not completed - setting fallback not possible';
    }
    else {
      this.fallbackMessage = 'Fallback attribute is already enabled for this profile';
    }
    return this.fallbackMessage;
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/card-details/card-details-modal.component.ts